import type { MangaItem } from "@/mocks/manga";

interface Props {
  manga: MangaItem;
  rank?: number;
}

export default function MangaCard({ manga, rank }: Props) {
  return (
    <article className="group overflow-hidden rounded-2xl bg-background-100 transition-transform duration-300 hover:-translate-y-1" data-product-shop>
      <div className="relative overflow-hidden">
        <div className="aspect-[5/7] w-full overflow-hidden bg-background-200">
          <img
            src={manga.cover}
            alt={`${manga.title}漫画封面`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        {rank !== undefined && (
          <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 font-heading text-base text-background-50 shadow">
            {rank}
          </span>
        )}
        <span className="absolute right-3 top-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {manga.status}
        </span>
      </div>

      <div className="p-3">
        <div className="flex items-start justify-between gap-2">
          <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 group-hover:text-primary-600">
            {manga.title}
          </h3>
          <span className="flex shrink-0 items-center gap-0.5 text-sm font-bold text-accent-600">
            <i className="ri-star-fill text-xs text-accent-500" aria-hidden="true"></i>
            {manga.rating}
          </span>
        </div>
        <p className="mt-1 text-xs text-foreground-600">
          {manga.genre} · {manga.chapters}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {manga.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}